import { connect } from "react-redux";
import { getUsersData, actionCreators as userActionCreators } from "Areas/Settings/users";
import { getWorkSpaces, actionCreators as workspaceActionCreators } from "Areas/Sidebar/WorkSpaces";
import actionCreators from "../redux/actionCreators";
import TaskStatisticsFilter from "./taskStatisticsFilter";
import { getFilterParams } from "../redux/selectors";
import getScope from "../utils/getScope";
const mapStateToProps = (state, ownProps) => ({
    users: getUsersData(state),
    workSpaces: getWorkSpaces(state),
    filterParams: getFilterParams(getScope(ownProps.selectedProjectId, ownProps.selectedWorkSpaceId), state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => {
        dispatch(userActionCreators.getUsers());
        dispatch(workspaceActionCreators.getWorkSpaces());
    },
    onGetTaskStatistics: (scope, params) => dispatch(actionCreators.getTaskStatistics(scope, params)),
    onSetTaskStatisticsFilterParams: (scope, params) => dispatch(actionCreators.setTaskStatisticsFilterParams(scope, params)),
    onClearAllTaskStatisticsFilterParams: (scope) => dispatch(actionCreators.clearAllTaskStatisticsFilterParams(scope))
});
export default connect(mapStateToProps, mapDispatchToProps)(TaskStatisticsFilter);
